/// <reference types="react" />
import * as React from 'react';
import { createElement as h, useEffect, useRef } from 'react';

interface GraphData {
  nodes: { id: string; label: string; maxLift: number }[];
  edges: { source: string; target: string; lift: number }[];
}

export default function AssociationGraph() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [data, setData] = React.useState<GraphData | null>(null);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    fetch('/api/v1/assoc/graph')
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return h('div', null, 'Loading graph data...');
  if (!data || data.nodes.length === 0) return h('div', null, 'No association data. Run an analysis first.');

  // Simple canvas-based graph rendering (D3.js replacement for MVP)
  // TODO: Replace with full D3.js force-directed graph in Phase 2

  return h('div', { ref: containerRef, style: { height: 400, overflow: 'auto' } },
    h('div', { style: { padding: 16, background: '#f8f9fa', borderRadius: 8 } },
      h('p', { style: { fontWeight: 600, marginBottom: 12 } }, `Association Graph (${data.nodes.length} nodes, ${data.edges.length} edges)`),
      h('div', { style: { display: 'flex', flexWrap: 'wrap', gap: 8 } },
        ...data.nodes.slice(0, 20).map(n =>
          h('div', {
            key: n.id,
            style: {
              padding: '6px 12px', background: 'white', borderRadius: 6,
              fontSize: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              borderLeft: `3px solid hsl(${Math.min(n.maxLift * 30, 360)}, 70%, 50%)`,
            },
          }, `${n.label} (lift: ${n.maxLift.toFixed(1)})`)
        ),
      ),
      h('p', { style: { marginTop: 16, color: '#888', fontSize: 12 } }, 'Full D3.js force graph available in next update.'),
    ),
  );
}

